import React, { useState, useEffect, useRef, useCallback } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import { projectAction } from "../../../../store/slices/managerActionSlice";

const ActionDropdown = ({
  handlerefresh,
  handleleadread,
  projects,
  index,
  row,
  dropdownRefs,
  openIndex,
  setOpenIndex,
  setProject,
  handleReject,
  setExpandedRowId,
  selected, // This was duplicated
  setSelected,
  setTaskTableRowId,
  SetShowprojectDetails,
  setServiceofuser,
  isViewOnly = false,
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [isRejected, setIsRejected] = useState(false);
  const [showforward, setshowforward] = useState("");
  const [allowforward, setallowforward] = useState(false);
  const triggerRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });

  const updateDropdownPosition = useCallback(() => {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const dropdownHeight = 80;
    const top =
      spaceBelow >= dropdownHeight ? rect.bottom + 2 : rect.top - dropdownHeight - 2;
    setDropdownPosition({
      top,
      left: rect.left,
      width: Math.max(rect.width, 120),
    });
  }, []);

  // Check if dropdown should be disabled
  const isDropdownDisabled =
    isViewOnly ||
    row.ProjectManagerAction === "reject-forward" ||
    row.ProjectManagerAction === "rejected" ||
    allowforward;

  const handleToggle = () => {
    if (isDropdownDisabled) {
      if (allowforward) {
        enqueueSnackbar("Awaiting feedback from the Primary Manager.", { variant: "error" });
      }
      return;
    }
    const willOpen = openIndex !== index;
    if (willOpen) {
      updateDropdownPosition();
    }
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    if (openIndex !== index) return;

    updateDropdownPosition();

    const onScrollOrResize = () => {
      updateDropdownPosition();
    };

    window.addEventListener("scroll", onScrollOrResize, true);
    window.addEventListener("resize", onScrollOrResize);

    return () => {
      window.removeEventListener("scroll", onScrollOrResize, true);
      window.removeEventListener("resize", onScrollOrResize);
    };
  }, [openIndex, index, updateDropdownPosition]);

  const handleprojectForward = async (row) => {
    try {
      await dispatch(projectAction({ projectid: row._id, action: "forward" }));
      enqueueSnackbar("Project Forwarded Successfully", {
        variant: "success",
      });
    } catch (error) {
      console.error("Failed to create task:", error);
    } finally {
      handlerefresh()
    }
  }

  const handleForwardClick = () => {
    if (isDropdownDisabled) {
      if (allowforward) {
        enqueueSnackbar("Awaiting feedback from the Primary Manager.", { variant: "error" });
      }
      return;
    }

    console.log("dgsdg", row)
    if (row?.isRead === false) {
      handleleadread(row)
    }
    if (row?.ProjectManagerAction !== "forward") {
      handleprojectForward(row)
    }

    setProject(row);
    setOpenIndex(null);
    setshowforward("Forward");
    setExpandedRowId(row._id);
    setSelected(!selected);
    setTaskTableRowId(null);
  };

  const handleRejectClick = () => {
    if (isDropdownDisabled) {
      if (allowforward) {
        enqueueSnackbar("Awaiting feedback from the Primary Manager.", { variant: "error" });
      }
      return;
    }

    handleReject(row, index);
    setOpenIndex(null);
  };

  useEffect(() => {
    dispatch(fetchAllProjects());
  }, [dispatch]);

  useEffect(() => {
    if (row?.Assignedperson?.length) {
      const hasRejected = row.Assignedperson.some(
        (person) => person.salespersonaction === "reject"
      );
      setIsRejected(hasRejected);
    } else {
      setIsRejected(false);
    }
  }, [row]);

  useEffect(() => {
    const currentEmail = localStorage.getItem("email");
    const rowQuotationId = row?.quotationId != null && String(row.quotationId).trim() !== ""
      ? String(row.quotationId).trim()
      : null;
    const matchByQuotationId = (project) =>
      rowQuotationId
        ? (project?.quotationId != null && String(project.quotationId).trim() === rowQuotationId)
        : (project?.ProjectName === row?.ProjectName);

    const matchingProjects = projects.filter(
      project =>
        matchByQuotationId(project) &&
        project?.AssignedManagerEmail?.includes(currentEmail)
    );

    if (matchingProjects.length === 0) {
      setallowforward(false);
      return;
    }

    const currentProject = matchingProjects[0];

    if (currentProject?.ResourceType === "Primary") {
      setallowforward(false);
      return;
    } else {
      const sameQuotationProjects = projects.filter(matchByQuotationId);

      const primaryProject = sameQuotationProjects.find(
        project => project.ResourceType === "Primary"
      );

      if (!primaryProject) {
        setallowforward(false);
        return;
      }

      const allSalespersonResponded = primaryProject?.Assignedperson[0];
      setallowforward(allSalespersonResponded?.manageraction !== "complete");
    }
  }, [projects, row]);

  // Get button text based on current state
  const getButtonText = () => {
    if (row.ProjectManagerAction === "forward") return "Forwarded";
    if (row.ProjectManagerAction === "rejected") return "Rejected";
    if (row.ProjectManagerAction === "reassign") return "Reassign";
    if (showforward === "Forward") return "Forward";
    return "Select Option";
  };

  return (
    <div className="relative w-full">
      <div
        ref={(el) => {
          triggerRef.current = el;
          if (dropdownRefs?.current) dropdownRefs.current[index] = el;
        }}
        className="w-[80%] items-center relative inline-block"
      >
        <div className="flex p-0 rounded-xl align-top items-center w-full relative">
          <ExpandMoreIcon
            className={`absolute right-0 m-auto bg-white border-r border-gray-400 ${isDropdownDisabled ? "cursor-not-allowed" : "cursor-pointer"
              }`}
            onClick={handleToggle}
          />

          <button
            type="button"
            onClick={handleToggle}
            className={`border w-full border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none text-xs ${isDropdownDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
              }`}
          >
            {getButtonText()}
          </button>
        </div>

        {/* Dropdown menu - fixed position so it stays visible when table overflows */}
        {openIndex === index && (
          <div
            className="z-[9999] text-start bg-white p-1 cursor-pointer overflow-y-auto text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
            style={{
              position: "fixed",
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              width: dropdownPosition.width,
              minWidth: "8rem",
            }}
          >
            {row.ProjectManagerAction === "forward" ? (
              <div className="p-1 hover:bg-gray-200 cursor-pointer" onClick={handleForwardClick}>
                View
              </div>
            ) : (
              <div className="p-1 hover:bg-gray-200 cursor-pointer" onClick={handleForwardClick}>
                Forward
              </div>
            )}

            <div
              className="p-1 cursor-pointer hover:bg-gray-200"
              onClick={() => {
                handleRejectClick();
                setExpandedRowId(null);
                SetShowprojectDetails(false);
                setServiceofuser(null);
                dispatch(fetchAllProjects());
                setProject(null);
                setOpenIndex(null);
                setshowforward("");
                setExpandedRowId(null);
                setSelected(null);
                setTaskTableRowId(null);
              }}
            >
              Reject
            </div>
          </div>
        )}
      </div>

      {isRejected && (
        <span
          title="Rejected"
          className="text-red-800 absolute right-1 top-1 font-bold text-xl cursor-default"
        >
          !
        </span>
      )}
    </div>
  );
};

export default ActionDropdown;


